import React from 'react'
import { connect } from 'react-redux'
import classes from './styles.module.scss'
// import { FormattedMessage } from 'react-intl'
import messages from './messages'
import { Button, Col, Form, Input, Row, message } from 'antd'
import { OTPRule } from 'utils/validateRules'
import { intl, recordCountlyEvent } from 'utils'
import Countdown from 'react-countdown-now'
import {
  getIdentity,
  verifyCaptcha,
  sendOTP,
  refreshCaptcha,
  toggleLoading,
} from 'store/siteConfig'

class OTP extends React.Component {
  firstRender=true
  constructor(props) {
    super(props)
    this.state = {
      date: Date.now(),
    }
  }

  renderer = ({ seconds, completed, ...res }) => {
    const className = classes.componentsOtp
    if (completed) {
      return (
        <Button
          type='link'
          size='small'
          loading={this.props.siteConfig.loading}
          disabled={!this.props.available}
          className={className}
          onClick={this.handleSend}
        >
          {intl().formatMessage(this.firstRender ? messages.send : messages.resend)}
        </Button>
      )
    } else {
      return (
        <Button
          type='link'
          size='small'
          className={className}
          disabled
        >
          {seconds}s
        </Button>
      )
    }
  }

  handleSend = (e) => {
    e.nativeEvent.stopImmediatePropagation()

    const {
      form,
      required = [],
      eventType,
      getIdentity,
      verifyCaptcha,
      sendOTP,
      toggleLoading,
      type
    } = this.props
    recordCountlyEvent({
      page_name: type === 'LOGIN' ? 'paypage_home' : 'paypage_pay_result',
      event_name: 'click',
      element_name: 'send'
    })
    form.validateFields([...required], (errors, values) => {
      if (!errors) {
        const { memberPhone, country, ...resetValues } = values
        resetValues.memberPhone = `${country}-${memberPhone}`
        console.log(memberPhone, country, 'memberPhone, country', required, values)
        if (values.captcha) {
          toggleLoading(true)
          verifyCaptcha({ captcha: values.captcha }).then(res => {
            // 验证码校验成功后发送OTP
            if (res.payload.request === 'success') {
              sendOTP().then((res) => {
                this.firstRender = false
                toggleLoading(false)
                if (res.payload.result === 'pass') {
                  this.setState({
                    date: Date.now() + 59000,
                  })
                } else {
                  this.setState({ date: Date.now() })
                }
              })
            } else {
              toggleLoading(false)
              this.props.form.resetFields(['captcha'])
              this.props.refreshCaptcha()
            }
          })
        } else {
          getIdentity({ eventType: eventType, serviceParams: resetValues }).then(
            (res) => {
              // 仅成功发送OPT后返回res
              if (res.payload.result === 'pass') {
                this.setState({
                  date: Date.now() + 59000,
                })
                this.firstRender = false
                toggleLoading(false)
              } else {
                message.error(res.payload.message)
                this.setState({ date: Date.now() })
              }
              toggleLoading(false)
            }
          )
        }
      }
    })
  }

  render() {
    const { form, onBlur } = this.props

    return (
      <Form.Item>
        <Row type='flex' justify='space-between'>
          <Col style={{ flex:1 }}>
            {form.getFieldDecorator(
              'otp',
              Object.assign(OTPRule(intl().formatMessage(messages.name)), {
                validateTrigger: 'onBlur',
                onBlur: () => {
                  typeof onBlur === 'function' && onBlur()
                },
              })
            )(
              <Input
                size='large'
                maxLength={6}
                pattern='\d*'
                placeholder={intl().formatMessage(messages.name)}
              />
            )}
          </Col>
          <Col>
            <Countdown
              key={this.state.date}
              date={this.state.date}
              renderer={this.renderer}
            />
          </Col>
        </Row>
      </Form.Item>
    )
  }
}

export default connect(
  (state) => ({
    siteConfig: state.siteConfig,
  }),
  {
    getIdentity,
    verifyCaptcha,
    sendOTP,
    refreshCaptcha,
    toggleLoading,
  }
)(Form.create()(OTP))
